interface Props {
  children: React.ReactNode;
}

const CardListItem = ({ children }: Props) => {
  return (
    <li className='flex items-center justify-between gap-x-6 py-5'>
      {children}
    </li>
  );
};
export default CardListItem;
